import React from "react";
import { TableHeader } from "../../commons";
import StockLimitsTableData from "./StockLimitsTableData";
import { STOCK_LIMIT_REPORT_TABLE_HEADERS } from "../../../constant/tableHeadersConstants/reportsConstant/stockLimitReportConst/stockLimitReportConst";
import { StockLimitReportDataType } from "../../../redux/reports/reportsType";

type AppProps = {
  fetching: boolean;
  data: StockLimitReportDataType[] | [];
  tableHeaders:any;
};

const StockLimitsTable = ({ fetching, data ,tableHeaders}: AppProps) => {
  return (
    <div className="jobsType">
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header-without-zindex">
          <TableHeader tableHeader={tableHeaders} />
        </thead>
        <tbody>
          <StockLimitsTableData
            data={data}
            tableHeader={tableHeaders}
          />
        </tbody>
      </table>
    </div>
  );
};

export default StockLimitsTable;
